import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {IReferencePathNodeSpecific, IReferencePathNodeWorkflowStep} from '~/interfaces/referencePathInterfaces'
import WorkflowStep from '../../../formability/form_builder/models/workflow/workflowStep'
import {ReferenceNodeType} from '~/enums/referenceNodeType'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'

export default class WorkflowStepPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.WorkflowStep

  constructor(private workflowStepNode: IReferencePathNodeWorkflowStep) {
    super();
  }

  get label(): string {
    return this.workflowStepNode.reference()?.titleOrDefault;
  }

  get nodes(): IReferencePathNodeWorkflowStep[] {
    return [this.workflowStepNode];
  }

  reference(): WorkflowStep {
    return WorkflowStep.repo.findById(this.workflowStepNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return null;
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision: boolean
    if (!this.referenceExists) {
      decision = false // own reference (workflow step) has to exist
    } else if (!node) {
      decision = false // workflow step node cannot be the last node in the list
    } else {
      const workflowStep = this.reference()
      switch (node.reference_type) {
        case ReferenceNodeType.FormSection:
          decision = workflowStep.form_section.id === node.reference_id;
          break;
        case ReferenceNodeType.FormPaymentsTotalCost: // intentional fall-through
        case ReferenceNodeType.FormPaymentsType: // intentional fall-through
        case ReferenceNodeType.FormPaymentsDate: // intentional fall-through
        case ReferenceNodeType.FormPaymentsLineItem:
          decision = workflowStep.isPaymentStep
          break;
        case ReferenceNodeType.FormElement:
          decision = Boolean(workflowStep.findElement(node.reference_id))
          break
        case ReferenceNodeType.WorkflowStepAction:
          decision = Boolean(Object.values(workflowStep.actions).find(a => a.id === node.reference_id))
          break
        case ReferenceNodeType.WorkflowGeneratedCert:
          decision = workflowStep.isCertificateStep;
          break;
        case ReferenceNodeType.StepCompleter:
          decision = true
          break;
        default:
          decision = false
          break
      }
    }
    this.debugCanLinkTo('WorkflowStepPathService', this.workflowStepNode, node, decision)
    return decision
  }

  referenceIsCollection = false
}